/**
 * 주의사항 : 반드시 env.js 가 import 되어야 한다.
 */
import $ from 'jquery';
import { loginDomain } from './Common';


const _APP_MODE = process.env.REACT_APP_MODE;
const _APP_KEY = process.env.REACT_APP_KEY; //BOX POS APP KEY
const _OPEN_API_URL = process.env.REACT_APP_OPEN_API_URL;
const _SESSION_KEY = "SI";
const _EXPIRE_KEY = "expire";
const _POST_METHOD = "POST";
const _GET_METHOD = "GET";

const _REFRESH_TOKEN_GRANT_TYPE = "refresh_token";
const _ACCESS_TOKEN_REFRESH_URI = "/app/cm/v1/cmm300/tokenRefresh";

/**
 * 여기서 사용하는 storage를 정의한다.
 */
var _STORAGE = sessionStorage;

//let sessionTimer = null;


////////////////////////////////////////////////////////////////////////////////////////////////////
//토큰 여부확인
function tokenChk () {
	let token = _STORAGE.getItem(_SESSION_KEY);
	if(token == null || token === undefined || token.trim() === ""){
		return false;
	}else{
		return true;
	}
}

// 액세스토큰비교
function accessChk () {
	let accessTokenExpired = parseJwt(_STORAGE.getItem(_SESSION_KEY))[_EXPIRE_KEY];
	//console.log(accessTokenExpired);
	console.log("isSessionExpire: session time="+accessTokenExpired+" cur time="+getCurTimestamp());
	// 액세스토큰 유효
	if( accessTokenExpired > getCurTimestamp() ){
		return true;
	// 액세스토큰 무효
	}else{
		return false;
	}
}

// 현재시간값
function getCurTimestamp(){
	return Math.floor(new Date().getTime()/1000);
}

// SI토큰변환
export function parseJwt (token) {
    var base64Url = token.split('.')[1];
    var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    var jsonPayload = decodeURIComponent(atob(base64).split('').map(function(c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));
    return JSON.parse(jsonPayload);
}

// refreshAPI
function refreshSend (url,param,successCB, errorCB, reSendUrl) {
	let errorCallBack = errorCB || AjaxErrorHandler;
	let sendData = {
		"appKey": _APP_KEY,
		"refreshToken": parseJwt(_STORAGE.getItem(_SESSION_KEY))["refreshToken"],
		"grantType": _REFRESH_TOKEN_GRANT_TYPE
	};
	$.ajax({
		type: _POST_METHOD,
		url: _OPEN_API_URL + _ACCESS_TOKEN_REFRESH_URI,
		beforeSend: function (xhr){
			xhr.setRequestHeader( "Content-Type", "application/json" );
			xhr.setRequestHeader( "appKey", _APP_KEY );
		},
		data: JSON.stringify(sendData),
		success: function(data){
			//console.log("refresh API Success", data);
			updateSession(data,url,param,successCB,errorCB,reSendUrl);
			//callback(data);
		},
		error: function (jqXHR, textStatus, exception, errorThrown){
			errorCallBack(jqXHR, textStatus, exception, errorThrown);
		}
	});
}
// refresh SI값 처리
function updateSession( newData,url,param,successCB,errorCB,reSendUrl ){
	let errorCallBack = errorCB || AjaxErrorHandler;
	let data = parseJwt(_STORAGE.getItem(_SESSION_KEY));
	if( data ){
		//console.log("========기본리딩");
		for(var key in newData ){
			//Token 갱신시에 2개의 필드는 널이 리턴되므로 업데이트 하지 않음
			if( key !== "grantType" && key !== "refreshTokenExpiresIn" ){
				data[key] = newData[key];
			}
		}
		for(var key in data ){
			if( key === "bplcNm"){
				data[key] = btoa(encodeURIComponent(data[key]));
			}
		}
		data["encYn"] = "Y";
	}else{
		alert("재로그인후 진행해주세요.");
		sessionStorage.clear();
		window.location.href="/";
	}
	//console.log('Update',data);
	$.ajax({
        type : _POST_METHOD,
		url :_OPEN_API_URL+"/api/cm/v1/cmi501/tokenIssue",
		beforeSend: function (xhr){
			xhr.setRequestHeader( "Content-Type", "application/json"  );
			xhr.setRequestHeader( "appKey", _APP_KEY );
		},
		data: JSON.stringify(data),
		success: function(res){
			//console.log('tokenIssue',res.token);
			_STORAGE.setItem(_SESSION_KEY,res.token);
			if(reSendUrl==="apiSend") {
				apiSend(url,param,successCB,errorCB);
			}else if(reSendUrl==="apiUploadSend") {
				apiUploadSend(url,param,successCB,errorCB);
			}else if(reSendUrl==="apiNoneAuthSend") {
				if(param.accessToken){
					param.accessToken = data.accessToken;
				}
				apiNoneAuthSend(url,param,successCB,errorCB);
			}
			
		},
		error: function (jqXHR, textStatus, exception, errorThrown){
			errorCallBack(jqXHR, textStatus, exception, errorThrown);
		}
	});
}


// SI가있는API (POST)
function apiSend(url,data,successCB, errorCB) {
	let successCallBack = successCB;
	let errorCallBack = errorCB || AjaxErrorHandler;
	let appKey = _APP_KEY;
	let sendData = data || {};
	//console.log('데이터',data);
	$.ajax({
		type: _POST_METHOD,
		url: _OPEN_API_URL + url,
		beforeSend: function (xhr){
			xhr.setRequestHeader( "Content-Type", "application/json"  );
			xhr.setRequestHeader( "appKey", appKey );
			xhr.setRequestHeader( "Authorization", parseJwt(_STORAGE.getItem(_SESSION_KEY))["tokenType"]+" "+parseJwt(_STORAGE.getItem(_SESSION_KEY))["accessToken"]);
		},
		data: JSON.stringify(sendData),
		success: function (data){
			successCallBack(data);
		},
		error: function (jqXHR, textStatus, exception, errorThrown){
			errorCallBack(jqXHR, textStatus, exception, errorThrown);
		}
	});
}

// 파일 업로드
function apiUploadSend (url,data,successCB, errorCB) {
	let successCallBack = successCB;
	let errorCallBack = errorCB || AjaxErrorHandler;
	let appKey = _APP_KEY;
	let formData = data || {};
	//console.log('데이터',data);

	$.ajax({
		type: _POST_METHOD,
		url: _OPEN_API_URL + url,
		beforeSend: function (xhr){
			xhr.setRequestHeader( "appKey", appKey );
			xhr.setRequestHeader( "Authorization", parseJwt(_STORAGE.getItem(_SESSION_KEY))["tokenType"]+" "+parseJwt(_STORAGE.getItem(_SESSION_KEY))["accessToken"]);
		},
		contentType : false,
		processData : false,
		enctype : 'multipart/form-data',
		data: formData,
		success: function (data){
			successCallBack(data);
		},
		error: function (jqXHR, textStatus, exception, errorThrown){
			errorCallBack(jqXHR, textStatus, exception, errorThrown);
		}
	});
}

// SI가 없어도 되는API (NoneAuth - POST)
function apiNoneAuthSend(url,data,successCB, errorCB) {
	let successCallBack = successCB;
	let errorCallBack = errorCB || AjaxErrorHandler;
	let appKey = _APP_KEY;
	let sendData = data || {};
		
	$.ajax({
		type: _POST_METHOD,
		url: _OPEN_API_URL + url,		
		beforeSend: function (xhr){
			xhr.setRequestHeader( "Content-Type", "application/json"  );
			xhr.setRequestHeader( "AppKey", appKey )
		},
		data: JSON.stringify(sendData),
		success: function (data){
			successCallBack(data);
		},
		error: function (jqXHR, textStatus, exception, errorThrown){
			errorCallBack(jqXHR, textStatus, exception, errorThrown);
		}
	});
}

export function callOpenApi (url,param,successCB, errorCB) {
	//console.log("=====================")
	
	//토큰 여부확인
	if(tokenChk()) {
		//액세스토큰유효
		if(accessChk()) {
			//console.log("액세스토큰유효");
			// AJAX통신시작
			apiSend(url,param,successCB, errorCB);
		}else{
			refreshSend(url,param,successCB, errorCB , "apiSend");
			//재갱신
			//console.log("만료재갱신");
		}
	//토큰없음 에러처리로감
	}else{
		alert("부정한접근입니다.");
		sessionStorage.clear();
		window.location.href="/";
	}
}

export function callOpenUploadApi (url,param,successCB, errorCB) {
	//console.log("=====================")
	
	//토큰 여부확인
	if(tokenChk()) {
		//액세스토큰유효
		if(accessChk()) {
			//console.log("액세스토큰유효");
			// AJAX통신시작
			apiUploadSend(url,param,successCB, errorCB);
		}else{
			refreshSend(url,param,successCB, errorCB, "apiUploadSend");
			//재갱신
			//console.log("만료재갱신");
		}
	//토큰없음 에러처리로감
	}else{
		alert("부정한접근입니다.");
		sessionStorage.clear();
		window.location.href="/";
	}
}

export function callOpenApiNonAuth (url,param,successCB, errorCB) {
	//console.log("=====================")
	
	//토큰 여부확인
	if(tokenChk()) {
		//액세스토큰유효
		if(accessChk()) {
			//console.log("액세스토큰유효");
			// AJAX통신시작
			apiNoneAuthSend(url,param,successCB, errorCB);
		}else{
			refreshSend(url,param,successCB, errorCB , "apiNoneAuthSend");
			//재갱신
			//console.log("만료재갱신");
		}
	//NoneAuth라서 토큰 없어도 진행
	}else{
		apiNoneAuthSend(url,param,successCB, errorCB);
	}
}
 
//////////////////////////////////////////////////////


function AjaxErrorHandler(jqXHR, textStatus, exception, errorThrown) {
    var msg = '';
    if(jqXHR.status == 404) {
		window.location.href="/404";
	}else{
		sessionStorage.clear();
		window.location.href="/500";
	}
    // if (jqXHR.status === 0) {
    //     //msg = 'Not connect.\n Verify Network.';
    // 	msg = '인터넷 연결이 불안정합니다. 네트워크 상태를 확인하시기 바랍니다.';    	
    // } else if (jqXHR.status == 404) {
	// 	window.location.href="/404";
	// 	return;
    // } else if (jqXHR.status == 500) {
	// 	window.location.href="/500";
	// 	return;
	// //	msg = '500';
    // } else if (jqXHR.status == 503) {
	// 	window.location.href="/500";
	// 	return;
	// //	msg = '500';
    // }else if (exception === 'parsererror') {
    //     msg = 'Requested JSON parse failed.';
    // } else if (exception === 'timeout') {
    //     msg = 'Time out error.';
    // } else if (exception === 'abort') {
    //     msg = 'Ajax request aborted.';
    // } else {
    //     msg = 'Uncaught Error.\n' + jqXHR.responseText + '\n' + exception;
    // }
    //cMsgbox("error", "Invalid async client request", '<h5>' + msg + errorThrown, "", "");
    //alert(msg);
}

/**SI 생성 */
/**
 * TODO: 차후 프로젝트 필요할수있으므로 주석처리
 * @param {t} data 
 * @param {*} successCB 
 * @param {*} errorCB 
 */
export function callSiApi(data, successCB, errorCB){
	var successCallBack = successCB ;
	var errorCallBack = errorCB || AjaxErrorHandler;
	$.ajax({
		type : "POST",
		url  :"https://devwww.ibkbox.net/COM001/getRefreshToken.do",
		data : JSON.stringify(data),
		contentType:"application/json",
		success : function(res){
			successCallBack(res)
		},
		error: function(e) {
			alert(e.responseJSON.message);
		}        
	});
}